import { createUseStyles } from 'react-jss';
import {
  BackgroundColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Easings } from '@picsart/design-system/foundation/easings';

const useStyles = createUseStyles(
  {
    '@keyframes spin': {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' },
    },
    spinner: {
      width: 40,
      height: 40,
      border: [3, 'solid', BackgroundColors.tint2],
      borderTopColor: PrimaryColors.base.default,
      borderRadius: CornerRadius.circle,
      animation: `$spin 0.8s ${Easings.linear} infinite`,
    },
    xsmall: {
      width: 14,
      height: 14,
      borderWidth: 2,
    },
    small: {
      width: 20,
      height: 20,
      borderWidth: 2,
    },
    large: {
      width: 60,
      height: 60,
      borderWidth: 4,
    },
  },
  { name: 'spinner' }
);

export default useStyles;
